<template>
  <div class="w100 Contenido">
    <Modal ref="Modal" v-show="ModalVisible" @Cerrar="CerrarModal" />
    <ModalEdicion ref="ModalEdicion" v-show="ModalEdicionVisible" @Cerrar="CerrarModalEdicion" />
    <ModalEditarRegistro ref="ModalEditarRegistro" @refresh="RefrescarInfo" />

    <Titulo
      seccion="Registro de Napa Freática Mensual"
      icon="ruler-vertical"
      :productor="NombreProductor()"
      :establecimiento="NombreEstablecimiento()"
    />
    <Descripcion>Consiste en el registro mensual de la variación del nivel de napa freática a lo largo del ciclo de cultivo.</Descripcion>

    <div class="SeccionLatLon cP" v-on:click.stop="EditarFreatimetro()">
      <span>Editar coordenadas </span>
      <font-awesome-icon
      icon="edit" size="4x" :style="{ color: '#348E54'}" :class="{ 'Titilando': Titilando()}"  class="h100 IconoEditar"/>
    </div>

    <div class="DivInfoData" v-bind:class="{ 'Visible': !DataActualizada }" ref="DivInfoData">
      <div class="fLeft">
        Info recuperada de fecha: <span ref="FechaData"></span>
      </div>


      <div class="fRight" v-on:click.stop="RefrescarInfo(InfoFreatimetro._IdFreatimetro)">
        <font-awesome-icon  icon="sync-alt" size="4x" :style="{ color: 'white'}"  class="IconoActualizar fLeft"/>
        <!-- Actualizar -->
        <div class="clear"></div>
      </div>

      <div class="clear"></div>
    </div>

    <table>
      <thead>
        <tr>
          <th>Valor</th>
          <th>Fecha</th>
          <th class="pR">
            <font-awesome-icon
            v-on:click.stop="NuevoRegistro()"
            v-show="this.$parent.Datos.AdminLogueado()"
            icon="plus-circle" size="4x" :style="{ color: '#005625'}" class="IconoAgregar Centro"/>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(p, index) in RegistrosPag" :key="index">
          <td class="c1">{{ ValorNoMarca(p._Valor) }}</td>
          <td>{{ p._FechaAlta }}</td>
          <td class="c3">
            <font-awesome-icon
              v-show="p._Id > 0 && AdminLogueado() && Online()"
              v-on:click.stop="EditarRegistro(p)"
              icon="edit"
              size="4x"
              class="h100 cP IconoEditar"
            />
            <font-awesome-icon
              v-show="p._Id > 0 && AdminLogueado() && Online()"
              v-on:click.stop="EliminarRegistro(p._Id, InfoFreatimetro._IdFreatimetro)"
              icon="trash-alt"
              size="4x"
              :style="{ color: '#934141' }"
              class="h100 IconoEliminar cP"
            />
            <font-awesome-icon
              v-show="p._Id <= 0"
              icon="spinner"
              size="4x"
              :style="{ color: '#000000' }"
              class="h100 IconoEliminar cP fa fa-spinner fa-spin"
            />
          </td>
        </tr>
      </tbody>
    </table>

    <div class="SinRegistros" v-show="this.MostrarSinRegistros">
      Aún no hay registros...
    </div>

    <SlidingPagination
      v-show="totalPages > 1"
      :slidingEndingSize="2"
      :slidingWindowSize="2"
      :current="currentPage"
      :total="totalPages"
      @page-change="CambioDePagina"
    ></SlidingPagination>

    <GraficoLineal v-if="DataEjeX.length > 0"
      :id-herramienta="5"
      type="line"
      TituloEjeY="ml"
      :DataEjeX="DataEjeX"
      :DataEjeY="DataEjeY"
    />

    <div class="BotonVerMapa dIB" @click="ClickVerMapa()">Ver Mapa</div>
  </div>
</template>

<script>
import SlidingPagination from "vue-sliding-pagination";
import Modal from '../../components/Utilidades/ModalNuevoRegistroFreatimetro';
import ModalEditarRegistro from '../../components/Utilidades/ModalEditarRegistroFreatimetro';
import axios from "axios";
import Clases from "../../Auxiliares/Clases.js";
import ManejoDatos from "../../Auxiliares/ManejoDatos.js";
import GraficoLineal from '../../components/Utilidades/GraficoLineal';
import ModalEdicion from '../../components/EdicionLatLon';

export default {
  name: "Freatimetro",
  data() {
    return {
      InfoFreatimetro: null, //El modelo lo setea la API
      RegistrosPag: [],
      MostrarSinRegistros: false,
      DataActualizada: true,
      _UserOk: false,
      Error: null,
      ModalVisible: false,
      ModalEdicionVisible: false,
      DataEjeX: [],
      DataEjeY: [],
      //Paginado
      currentPage: 0,
      totalPages: 0,
      ItemsPorPagina: 5,
      RecalcularPaginado(_InfoFreatimetro) {//TODO: llevar paginado a otro componente
        this.totalPages = Math.ceil(
          _InfoFreatimetro._Registros.length / this.ItemsPorPagina
        );
        var _Aux = [];
        for (let i = 0; i < _InfoFreatimetro._Registros.length; i++) {
          if (i >= (this.currentPage - 1) * this.ItemsPorPagina) {
            if (i < this.currentPage * this.ItemsPorPagina) {
              _Aux.push(_InfoFreatimetro._Registros[i]);
            }
          }
        }
        this.RegistrosPag = _Aux;
        this.MostrarSinRegistros = this.RegistrosPag.length <= 0;
      },
      NombreProductor(){
        if (this.InfoFreatimetro != null){
          return this.InfoFreatimetro._Productor;
        }
        return "";
      },
      NombreEstablecimiento(){
        if (this.InfoFreatimetro != null){
          return this.InfoFreatimetro._Establecimiento;
        }
        return "";
      },
      Online(){
        return this.$parent.Datos.AppOnline();
      },
      AdminLogueado(){
        return this.$parent.Datos.AdminLogueado();
      },
      Titilando(){
        if(this.InfoFreatimetro){
          if(this.InfoFreatimetro._Latitud == "" || this.InfoFreatimetro._Longitud == ""){
            return true;
          }
        }
        return false;
      }
    };
  },
  mounted() {
    this._UserOk = this.$parent.Datos.ChequearSesionUsuario(this.$router);
    if (this._UserOk) {
      this.RefrescarInfo(this.$route.params.Id);
    }
  },
  methods: {
    RefrescarInfo(_IdFreatimetro){
      _IdFreatimetro = _IdFreatimetro || this.$route.params.Id;
      if(this.VistaActual(_IdFreatimetro)){
        this.IntentoObtenerDataDeCache(_IdFreatimetro);
      }
      ManejoDatos.ObtenerRegistrosFreatimetro(_IdFreatimetro, this);
    },
    VistaActual(_IdFreatimetro){
      return (this.$route.params.Id == _IdFreatimetro && this.$route.name == "Freatimetro");
    },
    AuxiliaresVista(_IdFreatimetro){
      if(this.VistaActual(_IdFreatimetro)){
        this.currentPage = 1;
        this.AgregarPendientes(_IdFreatimetro);
        this.RecalcularPaginado(this.InfoFreatimetro);
        this.ActualizarDataGrafico();
      }
    },
    AgregarPendientes(_IdFreatimetro){
      var _Pendientes = Clases.RecuperarJsonDeStorage(this.KeyRegistrosPendientes(_IdFreatimetro));
      if(_Pendientes != null){
        _Pendientes.forEach(_Reg => {
          var _Reg = {
            _Id: 0,
            _Valor: _Reg.Valor,
            _FechaAlta: new Clases.Fecha()._Fecha
          };
          this.InfoFreatimetro._Registros.unshift(_Reg);
        });
      }
    },
    IntentoObtenerDataDeCache(_IdFreatimetro){
      try {
        var _Data = Clases.RecuperarJsonDeStorage(ManejoDatos.KeyDataCacheadaFreatimetros(_IdFreatimetro));
        if (_Data != null){
          this.InfoFreatimetro = _Data._Json;
          this.$refs.FechaData.innerHTML = _Data._Fecha._FechaYHora;
        }
      } catch (e) {
        console.log(e);
      }
    },
    KeyRegistrosPendientes(_IdFreatimetro){
      return ManejoDatos._KeyRegistrosPendientesGeneralFreatimetros + _IdFreatimetro;
    },
    CambioDePagina(selectedPage) {
      this.currentPage = selectedPage;
      this.RecalcularPaginado(this.InfoFreatimetro);
    },
    ActualizarDataGrafico() {
      var AuxX = [];
      var AuxY = [];

      if (this.InfoFreatimetro){
        if(this.InfoFreatimetro._Registros.length > 0){
          for (let index = 0; index < 10; index++) {
            const element = this.InfoFreatimetro._Registros[index];
            if(element){
              AuxX.push(element._FechaAlta);
              AuxY.push(element._Valor);
            }else{
              //AuxX.push("-");
              //AuxY.push(0);
            }
          }
        }
      }
      if (AuxX.length == 1){
        AuxX.push("");
        AuxY.push(0);
      }

      AuxX.reverse();
      AuxY.reverse();

      this.DataEjeX = AuxX;
      this.DataEjeY = AuxY;
    },
    NuevoRegistro(){
      this.$refs.Modal.Setear(this.InfoFreatimetro._IdFreatimetro);
      this.VerModal();
    },
    VerModal() {
      this.ModalVisible = true;
      setTimeout(() => {
          this.$refs.Modal.$refs.Valor.focus()
      }, 200);
    },
    CerrarModal() {
      this.ModalVisible = false;
    },
    EditarFreatimetro(){
      this.ModalEdicionVisible = true;
      this.$refs.ModalEdicion.Editar(this.InfoFreatimetro, this.InfoFreatimetro._IdFreatimetro, 2);
    },
    CerrarModalEdicion() {
      this.ModalEdicionVisible = false;
    },
    SetearNuevasCoordenadas(_Lat, _Lon){
      this.InfoFreatimetro._Latitud = _Lat;
      this.InfoFreatimetro._Longitud = _Lon;
    },
    EliminarRegistro(_Id, _IdFreatimetro){
      var _This = this;
      this.$confirm({
        title: "ATENCIÓN",
        message: "Estás seguro de eliminar el registro?",
        button: {
          yes: 'Si',
          no: 'No'
        },
        callback: confirm => {
          if(confirm){
            axios
              .post(_This.urlPosts + "/AgroIdeas/BajaRegistroFreatimetro", {
                IdUsuario: _This.$parent.Datos._User._ID,
                IdRegistro: _Id
              })
              .then(function (response) {
                _This.$parent.Notificacion("Registro eliminado!", "", "success", 3);
                _This.RefrescarInfo(_IdFreatimetro);
              })
              .catch(function (error) {
                _This.$parent.Notificacion("Error!", "", "error", 3);
                console.error(error);
              })
              .then(function () {
                //console.log("Ok");//LLega siempre que no haya catch
              });
          }
        }
      })
    },
    ClickVerMapa(){
      this.$router.push("/vermapa?t=2&idpres=" + this.$route.params.Id);
    },
    EditarRegistro(_Registro){
      this.$refs.ModalEditarRegistro.Show(_Registro);
    },
    ValorNoMarca(_Valor){
      return _Valor <= -5 ? "Fuera de rango" : _Valor + " m";
    }
  },
  components: {
    SlidingPagination,
    Modal,
    GraficoLineal,
    ModalEdicion,
    ModalEditarRegistro
  },
};
</script>

<style lang="scss" scoped>
.c1 {
  width: 40%;
}
.c3 {
  width: 20%;
}@import "../../Css/Secciones/Tabla.css";
</style>
